import React from 'react';
import './applicationsStyle.css';
import H2Title from './../../../../components/text/h2Title/h2Title'
import ApplicationCard from './applicationCard/applicationCard';

export default function Applications({applications, title}) {

    return (
        <section className='applications__container'>
            <H2Title title={title} />
            
            <div className='applications__list'>
                {applications?.map( (application, index) => (
                    <>
                    {application?.title && <ApplicationCard application={application} key={index}/>}
                    </>
                ))}
            </div>

        </section>
    );
}
